import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import { GetAllCompliances } from '@services/Compliance/Index.jsx';
import ptBR from 'antd/es/locale/pt_BR';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import { Spinner } from '@styles/loading.js';
import TextBlock from "@components/UI/TextBlock/Index..jsx";

const GridComplianceAssociadoSolicitacao = ({ state, setData, setSelectedRow, selectedRow, filters }) => {
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fetchData = async (currentPage, currentRowsPerPage, filters = {}) => {
    setLoading(true);
    try {
      const response = await GetAllCompliances(currentPage, currentRowsPerPage, filters);
      setData(response.items, response.totalItems);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  // Atualiza os dados quando a página ou o número de linhas por página muda
  useEffect(() => {
    fetchData(page, rowsPerPage, {
      tipoCompliance: filters.tipoCompliance || "",
      ano: filters.ano || "",
      servico: filters.servico || "",
      tipo: filters.tipo || "",
      nomeProcesso: filters.nomeProcesso || "",
    });
  }, [page, rowsPerPage, filters]);

  // Limpa o item selecionado se qualquer filtro estiver preenchido
  useEffect(() => {
    const hasFilters = Object.values(filters).some(
      (value) => value !== null && value !== undefined && value !== ""
    );
    if (hasFilters) {
      setSelectedRowKeys([]); // Limpa a seleção
    }
  }, [filters]);

  // Manipula a mudança de página
  const handlePageChange = (newPage, newRowsPerPage) => {
    setPage(newPage);
    if (newRowsPerPage) {
      setRowsPerPage(newRowsPerPage);
    }
  };

  // quando selectedRow muda, remove o item selecionado anteriormente
  useEffect(() => {
    if (selectedRow) {
      setSelectedRowKeys([selectedRow.id]);
    } else {
      setSelectedRowKeys([]);
    }
  }, [selectedRow]);

  // Manipula a seleção de linhas
  const handleRowSelection = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    if (selectedRows.length > 0) {
      setSelectedRow(selectedRows[0]); // Seleciona a primeira linha
    } else {
      setSelectedRow(null); // Limpa a seleção
    }
  };

  // Colunas da tabela
  const columns = [
    {
      title: 'CÓDIGO',
      dataIndex: 'codigo',
      key: 'codigo',
      width: '15%',
      sorter: (a, b) => a.codigo.localeCompare(b.codigo),
    },
    {
      title: 'ANO',
      dataIndex: 'ano',
      key: 'ano',
      width: '10%',
      sorter: (a, b) => a.ano.localeCompare(b.ano),
    },
    {
      title: 'COMPLIANCE',
      key: 'tipoCompliance',
      width: '20%',
      render: (_, record) => ((record.tipoCompliance) === "PROJETO" ? 'PROJETO' : 'SERVIÇO'),
      sorter: (a, b) => a.tipoCompliance - b.tipoCompliance,
    },
    {
      title: 'SERVIÇO',
      dataIndex: 'tipoServico',
      key: 'tipoServico',
      width: '20%',
      sorter: (a, b) => a.tipoServico.localeCompare(b.tipoServico),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'TIPO',
      dataIndex: 'tipoServicoAssociado',
      key: 'tipoServicoAssociado',
      width: '20%',
      sorter: (a, b) => a.tipoServicoAssociado.localeCompare(b.tipoServicoAssociado),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
    {
      title: 'PROCESSO',
      dataIndex: 'nomeProcesso',
      key: 'nomeProcesso',
      width: '15%',
      sorter: (a, b) => a.nomeProcesso.localeCompare(b.nomeProcesso),
      render: (text, record) => (
        <TextBlock>
          {text}
        </TextBlock>
      ),
    },
  ];

  return (
    <div className='p-3'>
      <div className='mb-3'>
        <h1> Lista de Compliances Registrados</h1>
      </div>

      <div>
        <ConfigProvider locale={ptBR}>
          <StyledTable
            columns={columns}
            dataSource={state.data}
            rowKey="id"
            loading={{
              spinning: loading,
              indicator: <Spinner />,
            }}
            pagination={{
              current: page,
              pageSize: rowsPerPage,
              total: state.totalRows,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: handlePageChange,
              onShowSizeChange: handlePageChange,
              showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`,
            }}
            scroll={{ y: '10rem' }}
            locale={{
              emptyText: <h2 className='m-3'>Nenhum registro disponível para exibição.</h2>,
            }}
            rowSelection={{
              type: 'radio',
              selectedRowKeys,
              onChange: handleRowSelection,
            }}
          />
        </ConfigProvider>
      </div>

    </div>
  );
};

export default GridComplianceAssociadoSolicitacao;